import React, { useEffect, useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import SimpleBar from 'simplebar-react';
/* eslint-disable no-extra-semi */
/**
 * CustomSelect component for rendering a dropdown select with options.
 * @component
 * @param {Object} props - Component properties
 * @param {string} [props.className] - Additional class name for styling
 * @param {string} [props.placeholder="Select Item"] - Placeholder text for the select when no item is chosen
 * @param {Array} [props.options=[]] - An array of objects representing the selectable options
 * @param {string} [props.value=""] - The currently selected value
 * @param {function} [props.onChange=null] - Callback function to handle selection changes
 * @param {boolean} [props.disabled=false] - Whether the select is disabled or not
 */
export default function CustomSelect(
  { className = "form-select", validation = "", placeholder = "Select Item", options = [],
    value = "", onChange = null, disabled = false, tag = "button", style = {}, ref, size='md' }) {
  const [state, setState] = useState("");
  const [flagImg, setFlagImg] = useState("");

  useEffect(() => {
    setState((value || ""));
    if (value.hasOwnProperty('flagImg')) {
      setFlagImg(value.flagImg);
    }
  }, [value]);

  /**
   * Handles the click event for an item in the dropdown menu.
   *
   * @function
   * @param {string} item - The selected item
   */
  function handleChange(item) {
    setState(item?.name);
    if (item.hasOwnProperty("flagImg")) {
      setFlagImg(item?.flagImg);
    }
    if (typeof onChange === "function") {
      onChange(item);
    }
  };

  return (
    <UncontrolledDropdown disabled={disabled} ref={ref} size={size}>
      <DropdownToggle
        tag={tag}
        type="button"
        className={`dropdowm-toggle d-flex align-items-center user-select-none ${className} btn-${size} ` + (!disabled ? validation : "disabled")}
        style={style}
      >
        {flagImg !== "" ?
          <img src={flagImg} className='me-1 rounded' height="15" />
          : null}
        {(state === "" ?
          <p className='m-0 text-muted w-100 text-start text-truncate'>{placeholder}</p>
          :
          <p className='m-0 w-100 text-start text-truncate'>{state}</p>
        )}
      </DropdownToggle>
      <DropdownMenu className='w-100'>
        <SimpleBar style={{ maxHeight: "220px", overflowX: "hidden" }}>
          {Array.isArray(options) && options.length > 0 ? (options || []).map((item, idx) => {
            return (
              <DropdownItem className='white-space-prewrap' onClick={() => handleChange(item)} key={idx}>
                {item.hasOwnProperty('flagImg') ? <img className='rounded me-1' height="15" src={item?.flagImg} /> : null}
                {item.hasOwnProperty('name') ? item.name : item}
              </DropdownItem>
            )
          }) : null}
        </SimpleBar>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
};